/**
 * @generated SignedSource<<0e681c45e288413150ff28ccd3422d5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterSpaceDensity = "BREEZY" | "COMFORTABLE" | "COMPACT" | "DEFAULT" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$data = {
  readonly helpCenterById: {
    readonly helpCenterBranding?: {
      readonly colors: {
        readonly primary: string | null;
        readonly secondaryColor: string | null;
      } | null;
      readonly cornerRadius: number | null;
      readonly logo: {
        readonly fileId: string | null;
        readonly url: string | null;
      } | null;
      readonly navigationBar: {
        readonly backgroundColor: string | null;
        readonly borderColor: string | null;
        readonly borderType: HelpCenterNavigationBarBorderType | null;
        readonly cornerRadius: number | null;
        readonly padding: boolean | null;
        readonly positionType: HelpCenterNavigationBarPositionType | null;
        readonly textColor: string | null;
      } | null;
      readonly spaceDensity: HelpCenterSpaceDensity | null;
      readonly typography: {
        readonly bodyFont: string | null;
        readonly headingFont: string | null;
      } | null;
    } | null;
    readonly type?: HelpCenterType | null;
  } | null;
  readonly hubMediaConfig: {
    readonly asapIssuer: string;
    readonly mediaCollectionName: string;
    readonly mediaToken: string;
    readonly mediaUrl: string;
  };
  readonly pageMediaConfig?: {
    readonly asapIssuer: string | null;
    readonly mediaCollectionName: string | null;
    readonly mediaToken: string | null;
    readonly mediaUrl: string | null;
  } | null;
  readonly " $fragmentType": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference";
};
export type hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$key = {
  readonly " $data"?: hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference$data;
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v1 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v2 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v3 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v4 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v5 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "cornerRadius"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hubAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isDraft"
    },
    {
      "kind": "RootArgument",
      "name": "operationType"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipPageMediaConfig"
    }
  ],
  "kind": "Fragment",
  "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "hubAri"
          },
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "concreteType": "HelpCenterMediaConfig",
        "kind": "LinkedField",
        "name": "hubMediaConfig",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v2/*: any*/),
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": (v3/*: any*/),
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": (v4/*: any*/),
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": (v5/*: any*/),
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "condition": "skipPageMediaConfig",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "pageMediaConfig",
          "args": [
            {
              "kind": "Variable",
              "name": "ari",
              "variableName": "pageAri"
            },
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "helpCenterAri",
          "variableName": "hubAri"
        },
        (v0/*: any*/)
      ],
      "kind": "LinkedField",
      "name": "helpCenterById",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "concreteType": "HelpCenterBranding",
              "kind": "LinkedField",
              "name": "helpCenterBranding",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HelpCenterLogo",
                  "kind": "LinkedField",
                  "name": "logo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "fileId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url"
                    }
                  ]
                },
                {
                  "concreteType": "HelpCenterBrandingColors",
                  "kind": "LinkedField",
                  "name": "colors",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "primary"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "secondaryColor"
                    }
                  ]
                },
                {
                  "concreteType": "HelpCenterNavigationBar",
                  "kind": "LinkedField",
                  "name": "navigationBar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "backgroundColor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "borderColor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "borderType"
                    },
                    (v6/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "padding"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "positionType"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "textColor"
                    }
                  ]
                },
                {
                  "concreteType": "HelpCenterBrandingTypography",
                  "kind": "LinkedField",
                  "name": "typography",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "headingFont"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "bodyFont"
                    }
                  ]
                },
                (v6/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "spaceDensity"
                }
              ]
            }
          ],
          "type": "HelpCenter"
        }
      ]
    }
  ],
  "type": "HelpCenterQueryApi"
};
})();

(node as any).hash = "03666b8e39b4e9cc9f5de02551833166";

export default node;
